import Vue from "vue";

import { Component } from "@/decorators";
import Bus from "@/utils/events/bus";

import reactMountHome from "../ReactMountHome.vue";

import fastActionComponent from "./fastaction/fastaction.vue";

import "./home.scss";

// Mesmo corte de src/react/shared/hooks/useIsMobile.ts e do navmenu.ts (< 768).
const MOBILE_QUERY = "(max-width: 767px)";

@Component({
    components: {
        fastActionComponent,
        reactMountHome,
    },
})
export default class HomeComponent extends Vue {
    isMobile = false;

    private mobileQuery: MediaQueryList = null;

    private onChangeMobile() {
        this.isMobile = this.mobileQuery.matches;
    }

    private created() {
        this.mobileQuery = window.matchMedia(MOBILE_QUERY);
        this.isMobile = this.mobileQuery.matches;
        this.mobileQuery.addEventListener("change", this.onChangeMobile);
    }

    private beforeMount() {
        Bus.$emit("hide-nav-menu", false);
    }

    private beforeDestroy() {
        this.mobileQuery.removeEventListener("change", this.onChangeMobile);
    }
}
